import { useState } from "react";
import SectionHeading from "@/components/feature/SectionHeading";
import { faqs } from "@/mocks/works";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section className="px-4 md:px-8 py-14 md:py-20 bg-background-100 border-y border-background-200">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <SectionHeading eyebrow="FAQ" title="常见问题" desc="关于参赛作品、作品集浏览与投稿流程，你可能会关心这些。" />
        </div>
        <div className="lg:col-span-8">
          <ul className="flex flex-col gap-3">
            {faqs.map((item, index) => {
              const open = openIndex === index;
              return (
                <li key={item.q} className="rounded-lg bg-background-50 border border-background-200 overflow-hidden">
                  <h3>
                    <button
                      type="button"
                      onClick={() => setOpenIndex(open ? -1 : index)}
                      aria-expanded={open}
                      className="w-full flex items-center justify-between gap-4 text-left px-5 py-4 cursor-pointer"
                    >
                      <span className="font-heading text-sm md:text-base font-bold text-foreground-950">
                        {item.q}
                      </span>
                      <span
                        className={`w-7 h-7 shrink-0 flex items-center justify-center rounded-md transition-colors ${
                          open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                        }`}
                      >
                        <i className={open ? "ri-subtract-line" : "ri-add-line"} />
                      </span>
                    </button>
                  </h3>
                  {open && (
                    <p className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed border-t border-background-200 pt-4">
                      {item.a}
                    </p>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
}